export default __webpack_public_path__ + "static/media/cynthia-spiering.edc3b165.jpg";